import {
    Button,
    Flex,
    HStack,
    Heading,
    Image,
    Spacer,
    Stack,
    Text,
    useBreakpointValue,
  } from '@chakra-ui/react';
  import { useNavigate } from 'react-router-dom';

  
  export default function Homepage() {
    const nav = useNavigate();
    return (
      <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
        <Flex p={8} flex={1} align={'center'} alignItems={'center'} justify={'center'}>
          <Stack spacing={6} w={'full'} maxW={'lg'}>
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
              <Text color={'#3077d5'} as={'span'}>             
                pNotas
              </Text>{' '}
            </Heading>
            <Text fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
              tu espacio para anotar tus necesidades.
            </Text>
            
              <Button
                rounded={'full'}
                // bg={'blue.400'}
                bg={"#3077d5"}
                color={'white'}
                _hover={{
                  bg: '#01d8fb',
                }}
                onClick={()=>{
                    nav("/login")
                }}>
                Iniciar Sesión
              </Button>
              <Button rounded={'full'} onClick={()=>{nav("/register")}}>Registrarse</Button>
            
            <Spacer />
            
          </Stack>
        </Flex>
        <Flex flex={1}>
          <Image
            alt={'Login Image'}
            objectFit={'cover'}
            src="/homebg2.jpeg"
          />
        </Flex>
      </Stack>
    );
  }